<template>
  <div class="chat-page">
    <div class="chat-navigation" ref="nav">
      <div class="chat-navigation-head">
        <div>
          <button class="create-chat" @click="createChat">
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" class="create-chat-ico" stroke-width="4" stroke-linecap="butt" stroke-linejoin="miter"><path d="M5 24h38M24 5v38"></path></svg>
          </button>
        </div>
        <div>
          <div class="navigation-close-bottom" @click="expandNav">
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" class="arco-icon arco-icon-close" stroke-width="4" stroke-linecap="butt" stroke-linejoin="miter"><path d="M9.857 9.858 24 24m0 0 14.142 14.142M24 24 38.142 9.858M24 24 9.857 38.142"></path></svg>
          </div>
        </div>
      </div>
      <div class="chat-navigation-body">
        <div class="navigation-item" :class="chatIndex === index ? 'navigation-active' : ''"
             v-for="(chat, index) in chats"
             :key="index"
             @click="chatList(index)">
          <div class="navigation-item-ico">
            <img src="@/assets/chat/head_icon/Kil_AI.png" alt="头像">
          </div>
          <div class="navigation-item-container">
            <h3 class="navigation-item-title">{{chat.name}}</h3>
            <p class="navigation-item-subtitle">{{chat.data[chat.data.length - 1] != null ? chat.data[chat.data.length - 1].content : ''}}</p>
          </div>
          <div class="remove-chat" @click.stop="removeChat(index)">
            <svg viewBox="64 64 896 896" focusable="false" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"></path></svg>
          </div>
        </div>
      </div>
      <div class="chat-navigation-bottom">
        <div class="bottom-user">
          <div class="bottom-user-ico">
            <img src="@/assets/chat/head_icon/baDoo.png" alt="用户">
          </div>
          <div class="bottom-user-info">
            <h2 class="user-name">无限使用</h2>
            <p class="user-balance">额度：999999999999999999999</p>
          </div>
        </div>
        <button class="bottom-logout" @click="logout">退出登录</button>
      </div>
    </div>
    <!-- entry -->
    <div class="chat_comment">
      <div class="chat_top">
        <div class="navigation-expand-bottom" @click.stop="expandNav">
          <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" class="arco-icon arco-icon-menu-unfold" stroke-width="4" stroke-linecap="butt" stroke-linejoin="miter" style="font-size: 24px;"><path d="M6 11h36M22 24h20M6 37h36M8 20.882 12.819 24 8 27.118v-6.236Z"></path></svg>
        </div>
        <!-- top -->
        <div class="chat_top_title">
          KIL_AI
        </div>
      </div>
      <div class="chatPage_container">
        <!-- middle -->
        <div class="chat_middle" id="chat_middle_item" ref="chatting">
          <!-- v-for="(dialogue, index) in chats[0].data" :key="index" -->
          <ChatList :chatIndex="chatIndex"/>
        </div>
        <div class="chat_menu">
          <div class="chat_left_menu">

          </div>
          <div class="chat_right_menu">
            <div class="chat_button" @click="reChats">
              <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M165.25312 240.5376c-21.34016 0-41.53344 0.3072-61.72672-0.06144-28.71296-0.53248-46.40768-25.25184-36.98688-51.11808 5.44768-14.92992 18.944-23.6544 37.7856-23.71584 54.55872-0.14336 109.11744-0.06144 163.69664-0.06144h45.79328c0-16.13824-0.02048-31.19104 0-46.24384 0.08192-61.37856 42.2912-103.5264 103.34208-103.40352 64.3072 0.1024 128.6144 0.1024 192.9216-0.02048 59.45344-0.1024 102.1952 42.47552 102.2976 102.1952 0.02048 15.17568 0 30.35136 0 46.91968 4.75136 0.2048 8.86784 0.55296 12.96384 0.55296 65.86368 0.04096 131.72736-0.16384 197.59104 0.14336 28.63104 0.14336 46.30528 25.25184 36.61824 50.91328-5.46816 14.45888-19.23072 23.63392-36.80256 23.8592-20.19328 0.26624-40.40704 0.06144-61.76768 0.06144-1.14688 15.99488-2.3552 31.0272-3.2768 46.08-3.44064 56.38144-6.7584 112.76288-10.19904 169.14432-3.33824 54.43584-6.77888 108.8512-10.21952 163.28704-3.584 56.75008-7.168 113.52064-10.81344 170.27072-2.94912 45.85472-5.20192 91.79136-9.29792 137.54368-4.15744 46.32576-44.66688 84.41856-91.19744 86.07744-35.04128 1.24928-70.144 0.512-105.20576 0.512-103.66976 0.04096-207.33952 0.16384-311.00928-0.06144-49.82784-0.1024-89.68192-30.9248-99.57376-78.35648-3.85024-18.5344-3.87072-37.90848-5.05856-56.95488-4.28032-68.03456-8.21248-136.0896-12.45184-204.12416-4.28032-68.42368-8.84736-136.82688-13.14816-205.25056-3.52256-55.99232-6.7584-111.98464-10.19904-167.97696-1.24928-19.74272-2.68288-39.46496-4.07552-60.2112z m80.09728 0.6144c2.12992 41.472 4.01408 81.55136 6.2464 121.58976 5.14048 91.77088 10.52672 183.54176 15.70816 275.31264 4.75136 84.39808 9.29792 168.79616 14.09024 253.19424 1.57696 27.8528 21.4016 47.04256 49.33632 47.08352 121.56928 0.2048 243.15904 0.2048 364.72832 0 27.81184-0.04096 47.73888-19.39456 49.3568-47.104 2.64192-44.72832 5.0176-89.45664 7.55712-134.18496 4.4032-77.39392 8.9088-154.76736 13.25056-232.16128 3.72736-66.49856 7.33184-132.99712 10.91584-199.49568 1.49504-27.87328 2.84672-55.74656 4.28032-84.25472-178.7904 0.02048-356.67968 0.02048-535.47008 0.02048zM637.37856 165.0688c0-15.62624 0.32768-30.69952-0.08192-45.75232-0.45056-16.50688-11.38688-27.52512-27.93472-28.18048-12.82048-0.512-25.68192-0.26624-38.54336-0.26624-49.82784-0.02048-99.67616-0.08192-149.504 0.02048-17.6128 0.04096-30.57664 8.41728-31.76448 22.79424-1.39264 16.87552-0.32768 33.93536-0.32768 51.4048 82.944-0.02048 164.90496-0.02048 248.15616-0.02048z" fill="#878b99"></path><path d="M478.0032 589.63968c0-79.09376 0.02048-158.16704-0.02048-237.2608-0.02048-15.48288 6.36928-27.42272 20.35712-33.91488 11.9808-5.55008 24.41216-4.77184 35.34848 3.35872 10.40384 7.74144 14.58176 18.5344 14.56128 31.51872-0.14336 76.34944-0.06144 152.71936-0.06144 229.0688 0 81.42848-0.04096 162.83648 0.04096 244.26496 0.02048 15.03232-6.08256 26.68544-19.33312 33.42336-11.79648 6.00064-24.22784 5.38624-35.40992-2.2528-11.14112-7.61856-15.5648-18.67776-15.54432-32.13312 0.14336-78.68416 0.06144-157.3888 0.06144-236.07296zM695.37792 358.6048c-3.44064 63.01696-6.88128 126.0544-10.28096 189.07136-3.584 66.1504-7.10656 132.28032-10.69056 198.43072-1.51552 28.01664-2.8672 56.03328-4.79232 84.00896-1.37216 20.09088-18.82112 34.7136-39.05536 33.56672-18.55488-1.04448-31.8464-16.24064-30.78144-36.80256 3.29728-63.42656 7.12704-126.81216 10.62912-190.21824 3.50208-63.7952 6.8608-127.61088 10.28096-191.42656 1.67936-31.51872 3.05152-63.05792 5.07904-94.55616 1.14688-17.7152 13.96736-32.17408 29.40928-34.7136 16.4864-2.72384 31.27296 3.52256 37.02784 17.57184 3.11296 7.63904 3.13344 16.54784 4.54656 24.8832-0.47104 0.04096-0.9216 0.1024-1.37216 0.18432zM417.8944 745.63584c1.3312 27.60704 2.92864 55.21408 3.87072 82.8416 0.7168 21.07392-11.53024 34.83648-30.22848 35.24608-19.39456 0.4096-34.05824-14.17216-35.16416-34.34496-5.20192-96.01024-10.58816-192.02048-15.81056-288.0512-3.39968-62.58688-6.84032-125.17376-9.80992-187.78112-1.04448-22.016 10.69056-36.51584 28.9792-37.92896 21.54496-1.65888 37.70368 10.93632 39.99744 33.30048 2.12992 20.8896 2.37568 41.96352 3.29728 62.976 4.93568 111.24736 9.85088 222.49472 14.76608 333.74208h0.1024z" fill="#878b99"></path></svg>
            </div>
          </div>
        </div>
        <!-- foot -->
        <div class="chat_foot">
          <!-- context -->
          <textarea v-model="context" @keydown.enter.prevent="sendMessage" class="chat_context" id="chat_context_item" cols="30" placeholder="请输入"></textarea>
          <div class="chat_commit" id="button" @click="sendMessage">发送</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {get, post} from "@/net";
  import {getNowDate} from "@/utils";
  import ChatList from "@/components/chat/ChatList.vue";

  export default {
    name: 'ChatIndex',
    components: {ChatList},
    data() {
      return {
        context: '',
        chats: this.$store.state.chats,
        chatIndex: 0
      }
    },
    methods: {
      sendMessage(){
        if (this.context.length > 0) {
          let index = this.chats[this.chatIndex].data.push({"role":"user", "content": this.context, "time": getNowDate()})
          this.$nextTick(this.chattingScroll)
          this.context = '';
          this.submitTo(this.chatIndex, index)
        }else {
          this.$notify.info('内容不能为空')
        }
      },
      /* 消息提交服务器 */
      submitTo(chatIndex, index){
        const tempIndex = chatIndex
        this.$set(this.chats[tempIndex].data[index - 1], 'success', true)
        post('/api/chat/send-text-message', this.chats[tempIndex].data.filter(item => item.success === true), (message, data) =>{
          if (data !== null) {
            data['time'] = getNowDate()
            if (this.chats[tempIndex]) {
              this.chats[tempIndex].data.push(data)
              this.$nextTick(this.chattingScroll)
            }
          }else {
            if (this.chats[tempIndex]) {
              this.$set(this.chats[tempIndex].data[index - 1], 'success', false)
            }
            this.$notify.info(message)
          }
        },message => {
          if (this.chats[tempIndex]) {
            this.$set(this.chats[tempIndex].data[index - 1], 'success', false)
          }
          this.$notify.warning(message)
        }, () => {
          if (this.chats[tempIndex]) {
            this.$set(this.chats[tempIndex].data[index - 1], 'success', false)
          }
          this.$notify.error('发生了一点错误，请稍后在重试')
        })
      },
      /* 页面滚动 */
      chattingScroll(){
        const element = this.$refs.chatting
        element.scrollTop = element.scrollHeight
      },
      reChats() {
        if (confirm('确定清除聊天记录吗')) {
          this.chats[this.chatIndex].data = []
        }
      },
      /* 对话消息列表跳转 */
      chatList(index) {
        if (index <= 0 || index == null) {
          index = 0
        }
        this.chatIndex = index
        this.$nextTick(this.chattingScroll)
        this.expandNav()
      },
      /* 创建对话 */
      createChat() {
        this.chats.push({name: 'KIL_AL', data: []})
      },
      /* 删除对话 */
      removeChat(index) {
        if (confirm('确定删除该对话吗')) {
          this.chats.splice(index, 1)
          this.$nextTick(() => {this.chatList(index - 1)})
        }
      },
      /* 退出登录 */
      logout() {
        if (confirm('确定退出账号吗')) {
          // this.$store.state.auth.user = null
          get('/api/auth/logout', () => {
            localStorage.removeItem('authorization')
            this.$router.push('/')
          })
        }
      },
      /* 导航栏显示关闭 */
      expandNav() {
        const nav = this.$refs.nav
        if (nav.style.left === '0px') {
          nav.style.left = '-100%'
        }else {
          nav.style.left = '0'
        }
      },
      /* 点击菜单外部关闭 */
      handleClickOutside(event) {
        // 检查点击的目标元素是否在菜单内
        if (!this.$refs.nav.contains(event.target)
            && this.$refs.nav.style.left === '0px') {
          this.expandNav()
        }
      }
    },
    watch: {
      /* 深度监视chats属性 */
      chats: {
        deep: true,
        handler(value) {
          localStorage.setItem('chats', JSON.stringify(value))
        }
      }
    },
    mounted() {
      // 监听点击事件
      document.addEventListener('click', this.handleClickOutside)
      /* 重新发送 */
      this.$bus.$on('reSend', index => {
        const tempIndex = this.chatIndex
        let chatData = this.chats[tempIndex].data[index];
        this.$set(chatData, "time", getNowDate())
        // 删除当前元素
        this.chats[tempIndex].data.splice(index, 1)
        // 将元素放到最后
        let dataIndex = this.chats[tempIndex].data.push(chatData)
        this.chattingScroll()
        this.submitTo(tempIndex, dataIndex)
      })
      /* 滚动到最底部 */
      this.chattingScroll()
    },
    beforeDestroy() {
      // 移除点击事件监听
      document.removeEventListener('click', this.handleClickOutside)
    }
  }
</script>

<style scoped>
  *{
    padding: 0;
    box-sizing: border-box;
  }

  .chat-page{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
  }
  /* 侧边导航 */
  .chat-navigation{
    width: 300px;
    height: 100%;
    box-sizing: content-box;
    transition: all 0.3s ease-in-out;
  }

  .chat-navigation-head{
    width: 100%;
    height: 50px;
    padding: 8px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
    border-bottom: 1px solid rgb(229, 231, 235);
    background-color: white;
  }
  .create-chat{
    width: 46px;
    height: 32px;
    color: #165dff;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s linear;
    border: 1px solid #ebebeb;
    background-color: #ffffff;
  }
  .create-chat-ico{
    width: 14px;
    height: 14px;
  }
  .create-chat:hover{
    background-color: #f7f8fb;
  }

  .chat-navigation-body{
    width: 100%;
    height: calc(100% - 160px);
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    padding: 8px 10px 0 10px;
    background-color: #fafbfc;
  }

  .navigation-item{
    width: 100%;
    height: 64px;
    position: relative;
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-bottom: 8px;
    box-sizing: border-box;
    border-radius: 8px;
    color: rgb(98, 101, 105);
    background-color: rgb(255, 255, 255);
    border: 1px solid #ebebeb;
    //box-shadow: 0 2px 4px 0 rgba(0,0,0,.05);
    transition: all 0.2s ease-in-out;
  }
  .navigation-item:hover{
    background-color: #f7f8fb;
  }
  .navigation-active{
    border: 1px solid #165dff;
  }
  /* 对话列表头像 */
  .navigation-item-ico{
    width: 40px;
    height: 40px;
    margin-right: 16px;
  }
  .navigation-item-ico img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    overflow: hidden;
    background-color: #ffffff;
  }
  /* 对话内容 */
  .navigation-item-container{
    width: 100%;
    overflow: hidden;
  }
  .navigation-item-title{
    font-size: 14px;
    margin: 0 0 4px 0;
    font-weight: 500;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .navigation-item-subtitle{
    font-size: 14px;
    margin: 0;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .remove-chat{
    width: 16px;
    height: 16px;
    opacity: 0;
    visibility: hidden;
    position: absolute;
    transition: all 0.2s linear;
    top: 10px;
    right: 10px;
  }
  .navigation-item:hover .remove-chat{
    opacity: 1;
    color: #165dff;
    visibility: visible;
  }

  /* 对话列表底部 */
  .chat-navigation-bottom{
    width: 100%;
    height: 110px;
    padding: 8px;
    overflow: hidden;
    box-sizing: border-box;
    background-color: #ffffff;
    border-top: 1px rgb(229, 231, 235) solid;
  }
  .bottom-user{
    padding: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
  .bottom-user-ico{
    width: 40px;
    height: 40px;
    margin-right: 16px;
  }
  .bottom-user-ico img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    object-fit: cover;
  }
  .bottom-user-info{
    margin-left: 4px;
    overflow: hidden;
  }
  .user-name{
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #626569;
  }
  .user-balance{
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #626569;
  }
  .bottom-logout{
    width: 100%;
    height: 32px;
    color: rgb(78, 89, 105);
    text-align: center;
    background-color: rgb(242, 243, 245);
    border: 1px solid rgb(217, 217, 217);
    transition: all 0.1s linear;
  }
  .bottom-logout:hover{
    background-color: rgb(229, 230, 235);
  }

  /* 聊天框界面 */
  .chat_comment{
    flex: 1;
    width: 100%;
    height: 100%;
    margin: auto;
    box-sizing: border-box;
  }
  /* top */
  .chat_top{
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 4px solid #f4f5f7;
  }
  .navigation-expand-bottom{
    width: 24px;
    height: 24px;
    display: none;
    color: #878b99;
    margin-left: 20px;
    transition: all 0.2s linear;
  }
  .navigation-expand-bottom:hover{
    color: #626469;
  }
  .navigation-close-bottom{
    width: 20px;
    height: 20px;
    display: none;
    color: #878b99;
    transition: all 0.2s linear;
  }
  .navigation-close-bottom:hover{
    color: #626469;
  }
  .chat_top_title{
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    font-weight: 550;
    padding-left: 20px;
  }
  /* middle */
  /* 左边 */
  .chat_middle{
    flex: 1;
    width: 100%;
    position: relative;
    box-sizing: border-box;
    overflow-y: scroll;
    overflow-x: hidden;
    scroll-behavior: smooth;
    border-width: 0;
  }
  /* foot */
  .chat_foot{
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-end;
    position: relative;

  }
  .chat_context{
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: #212b36;
    box-sizing: border-box;
    outline: none;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-width: 0;
    padding: 16px;
  }
  textarea::-webkit-input-placeholder {
    color: #737373;
  }
  .chat_commit{
    width: 80px;
    height: 30px;
    font-size: 14px;
    color: white;
    background-color: #4F7cff;
    line-height: 30px;
    text-align: center;
    border-radius: 5px;
    margin-right: 20px;
    margin-bottom: 40px;
  }
  .chat_context{
    resize: none;
  }
  .chat_context::placeholder{
    color: black;
    font-weight: 500;
  }
  /* 自定义样式 */
  .chatPage_container{
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    height: calc(100% - 50px);
  }
  /* 聊天功能按钮 */
  .chat_menu{
    height: 40px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-top: 4px solid #f4f5f7;
    box-sizing: border-box;
  }
  .chat_left_menu{

  }
  .chat_right_menu{

  }
  .chat_button{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    padding-top: 10px;
  }

  @media screen and (max-width: 1023px) {
    .navigation-expand-bottom{
      display: block;
    }

    .navigation-close-bottom{
      display: block;
    }

    .chat-navigation{
      position: absolute;
      top: 0;
      left: -100%;
      z-index: 1;
      border-right: 1px solid #f4f5f7;
    }

    .remove-chat{
      opacity: 1;
      visibility: visible;
    }
  }
</style>